module.exports = __webpack_public_path__ + "img/1-3.8d51e7f1.jpg";